// import _ from 'lodash'
import vm from '../main'

const internals = {}


internals.addTechnician = function(technician) {
    // Filter out properties not needed
    technician = (({
        name,
        mobileNumber,
        dateOfBirth,
        manager,
        languageKnown,
        defaultLanguage,
        status,
        addressDetails,
        userPin,
        region,
        deviceId,
        _id,
        site,
        userType
    }) => {
        return {
            name,
            mobileNumber,
            dateOfBirth,
            manager,
            languageKnown,
            defaultLanguage,
            status,
            addressDetails,
            userPin,
            region,
            deviceId,
            _id,
            site,
            userType
        }
    })(technician)

    return vm.$tempuserDataRepository
        .create(technician)
        .then(result => {
            technician = result.data
            return technician

        })
        .catch(error => {
            console.error('technicianService.createRole-error:\n', error)
            throw error
        })
}

internals.updateTechnician = function(technician) {
    technician = Object.assign({}, technician)
        // Filter out properties not needed
    technician = (({
        name,
        mobileNumber,
        dateOfBirth,
        manager,
        languageKnown,
        defaultLanguage,
        status,
        addressDetails,
        userPin,
        region,
        deviceId,
        _id,
        site,
        userType
    }) => {
        return {
            name,
            mobileNumber,
            dateOfBirth,
            manager,
            languageKnown,
            defaultLanguage,
            status,
            addressDetails,
            userPin,
            region,
            deviceId,
            _id,
            site,
            userType
        }
    })(technician)
    return vm.$tempuserDataRepository
        .update(technician._id, technician)
        .then(result => {
            technician = result.data
            return technician
        })
        .catch(error => {
            console.error('technicianUpdate.update-error:\n', error)
            throw error
        })
}

export default internals


// WEBPACK FOOTER //
// ./src/services/technician.service.js